import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Google Translate en cada email',
    costo: 'El cliente lo nota — perdés credibilidad'
  }, {
    sin: 'Sin sistema de estudio',
    costo: 'Dos años "aprendiendo" y en el mismo nivel'
  }, {
    sin: 'Sin conocer los falsos amigos',
    costo: 'Un error en el momento equivocado arruina un trato'
  }, {
    sin: 'Sin vocabulario técnico',
    costo: 'Quedás afuera de reuniones y decisiones'
  }, {
    sin: 'Sin confianza para escribir en PT',
    costo: 'Clientes brasileños que se van con otro proveedor'
  }, {
    sin: 'Viajás a Brasil de vacaciones o negocios',
    costo: 'Dependés de señas y portuñol básico que limita tu experiencia'
  }];
  return <section className="py-20 bg-zinc-900 text-white" data-id="element-45">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-48">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-49">
          <div className="min-w-[600px]" data-id="element-50">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-51">
              <div className="font-bold text-emerald-300 uppercase text-sm tracking-wider" data-id="element-52">
                Sin el Megapack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-53">
                Lo que realmente perdés
              </div>
            </div>

            <div className="space-y-2" data-id="element-54">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-black/60 rounded-xl p-4 items-center border border-emerald-900/30" data-id="element-55">
                  <div className="text-zinc-100 font-medium" data-id="element-56">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-57">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-emerald-400 mt-4 md:hidden" data-id="element-58">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-emerald-600 to-green-800 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-59">
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-60">
            🇧🇷🇦🇷 "La próxima vez que un brasileño te escriba, vas a saber
            exactamente qué responder — en portugués real."
          </p>
        </motion.div>
      </div>
    </section>;
}